import React from 'react';
import PropTypes from 'prop-types';
import SovosSelect from 's1-ui/sovos-select/SovosSelect';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialTextField from "../../../../shared/components/connectedTextField/c/materialTextField/MaterialTextField";
import MonthPicker from 'shared/components/monthPicker/MonthPicker';

const reportFormats = ['xlsx', 'csv', 'Custom'];

class ReportEditor extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      pickerPeriod: {
        startMonth: '',
        startYear: 0,
        endMonth: '',
        endYear: 0
      },
      report: {
        id: '',
        periodId: '',
        endPeriodId: '',
        format: 'xlsx',
        extension: '',
        delimiter: ''
      }
    };
    this.props.reportsActions.fetchReportsTemplates();
  }

  handleInputChange = (fieldName, value) => {
    const inputValue = fieldName === 'extension'
      ? value.replace(/[\W_]+/g,"").substring(0,5)
      : value.substring(0,5);

    this.setState(oldState => ({ report: {...oldState.report, [fieldName]: inputValue} }),
      () =>  this.props.onReportsTemplatesChange(this.state.report));
  };

  handleReportInformationChange = (fieldName, value) => {
    this.setState( oldState => ({
      report: {
        ...oldState.report,
        [fieldName]: value
      }
    }),() => this.props.onReportsTemplatesChange(this.state.report));
  };

  handlePeriodChange = (year, month, fieldName) => {
    const pickerPeriod = {...this.state.pickerPeriod, [fieldName + 'Month']: month, [fieldName + 'Year']: year };
    const periodId = fieldName === 'start' ?
      (month + 1) <= 9 ? `${year}0${month + 1 }` : `${year}${month + 1}` : this.state.report.periodId;
    const endPeriodId = fieldName === 'end' ?
      (month + 1) <= 9 ? `${year}0${month + 1 }` : `${year}${month + 1}` : this.state.report.endPeriodId;

    this.setState(oldState => ({report: {...oldState.report , periodId, endPeriodId}, pickerPeriod }),
      () => this.props.onReportsTemplatesChange(this.state.report));
  };

  render() {
    const { reportsTemplates } = this.props;
    const { report, pickerPeriod } = this.state;

    return (
      <div className="report-editor report-editor-period-picker">
        <MonthPicker
          defaultLabel="Start Period"
          onChange={ (year, month) => this.handlePeriodChange(year, month, 'start') }
          month={ pickerPeriod.startMonth }
          year={ pickerPeriod.startYear }
          yearsBefore={ 4 }
          yearsBeyond={ 1 }

        />
        <hr style={ { marginTop: '20px' } } />
        <MonthPicker
          defaultLabel="End Period"
          onChange={ (year, month) => this.handlePeriodChange(year, month, 'end')  }
          month={ pickerPeriod.endMonth }
          year={ pickerPeriod.endYear }
          yearsBefore={ 4 }
          yearsBeyond={ 1 }
          disabled={ pickerPeriod.startYear === 0 }
          errorText={ parseInt(report.endPeriodId) < parseInt(report.periodId) ? 'End period should be greater or equal than the start period' : '' }
        />
        <hr style={ { marginTop: '20px' } } />
        <div>
          <SovosSelect
            value={ report.id }
            onChange={ ev => this.handleReportInformationChange('id', ev.target.value) }
            displayEmpty
          >
            <MenuItem value="" disabled style={ { color: '#bcbcbc' } }>
              Select report
            </MenuItem>
            {
              reportsTemplates.map((reportTemplate, index) => (
                <MenuItem key={ index } value={ reportTemplate.id } >
                  { reportTemplate.name }
                </MenuItem>
              ))
            }
          </SovosSelect>
        </div>
        <hr style={ { marginTop: '20px' } } />
        <div style={ { display: 'flex', alignItems: 'baseline'} }>
          <p style={ {marginRight: '15px', fontSize: '16px'} }>File Format:</p>
          <SovosSelect
            value={ report.format }
            onChange={ ev => this.handleReportInformationChange('format', ev.target.value) }
            displayEmpty
          >
            {
              reportFormats.map((format, index) => (
                <MenuItem key={ index } value={ format } >
                  { format }
                </MenuItem>
              ))
            }
          </SovosSelect>
        </div>
        {report.format === 'Custom' &&
        <div>
          <MaterialTextField
            name={ 'delimiter' }
            label={ 'Column Delimiter' }
            value={ report.delimiter }
            onChange={ ev =>this.handleInputChange(ev.target.name, ev.target.value) }
            required
          />
          <MaterialTextField
            name={ 'extension' }
            label={ 'File Extension' }
            value={ report.extension }
            onChange={ ev =>this.handleInputChange(ev.target.name, ev.target.value) }
            required
          />
        </div>
        }
      </div>
    );
  }
}

ReportEditor.propTypes = {
  reportsTemplates: PropTypes.array,
  onReportsTemplatesChange: PropTypes.func.isRequired,
  reportsActions: PropTypes.shape({
    fetchReportsTemplates: PropTypes.func
  }).isRequired
};

export default ReportEditor;



// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportEditor/ReportEditor.js